import { UNSAVED_CHANGES_MESSAGES } from "../constants/messages";
import { DiscardConfirmDialog } from "./DiscardConfirmDialog";

interface UnsavedChangesDialogProps {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export function UnsavedChangesDialog({
  open,
  onConfirm,
  onCancel,
}: UnsavedChangesDialogProps): JSX.Element {
  return (
    <DiscardConfirmDialog
      open={open}
      title={UNSAVED_CHANGES_MESSAGES.title}
      description={UNSAVED_CHANGES_MESSAGES.description}
      confirmLabel={UNSAVED_CHANGES_MESSAGES.confirm}
      cancelLabel={UNSAVED_CHANGES_MESSAGES.cancel}
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  );
}
